import { Component, Input } from '@angular/core';
import { ErStatusKind, normalizeStatus } from './status';

/** Status pill: uppercase mono micro-label + dot. Label defaults to the raw status. */
@Component({
  selector: 'er-status-pill',
  template: `
    <span class="er-pill" [ngClass]="cls">
      <span class="er-dot" [ngClass]="dotCls"></span>{{ label || status || '—' }}
    </span>`
})
export class ErStatusPillComponent {
  @Input() status: string | null | undefined;
  @Input() label: string | null | undefined;

  get kind(): ErStatusKind { return normalizeStatus(this.status); }
  get cls(): string { return this.kind === 'neutral' ? '' : 'er-pill--' + this.kind; }
  get dotCls(): string { return this.kind === 'neutral' ? '' : 'er-dot--' + this.kind; }
}
